export default "__VITE_ASSET__C3PE2dFV__"